// extracted by mini-css-extract-plugin
export default {"form":"mealitemform_form__uLqGw"};